// extracted by mini-css-extract-plugin
export default {"vpaContainer":"mE_IvG"};